import { useRouter } from '@capsicum/common-web';
import { useMemo } from 'react';

/**
 * V2 FT Migration Side Flows are Send Flow, Topup Flow, Requirements Flow, and Export Private
 * Key and Delete Account Flow. This hook indicates whether such Side Flows are
 * ongoing during the V2 FT Migration Flow.
 *
 * V2 Migration InitFlow hides itself when pages on this whitelist are in focus,
 * thus enabling users to send & topup & delete account. As soon as users navigate
 * to any pages off this whitelist, V2 Migration InitFlow is back in focus,
 * requiring users to follow the V2 migration screen instructions.
 *
 * This whitelist doesn't include the pathnames of Capsicum Gateway and Chilipay.com
 * because those are out of the app.socios.com web app Next.js routing.
 */
export const useV2MigrationWhitelistedScreenChecker = () => {
	const { pathname } = useRouter();

	return useMemo(
		() =>
			[
				'/nc-wallet/receive',
				'/nc-wallet/send',
				'/nc-wallet/send/chiliz',
				'/nc-wallet/send/chiliz/confirm',
				'/nc-wallet/send/fan-tokens',
				'/nc-wallet/send/fan-tokens/confirm',
				'/nc-wallet/send/recipients',
				'/nc-wallet/send/recipients/create',
				'/nc-wallet/send/recipients/edit',
				'/nc-wallet/topup',
				'/requirements',
				'/settings/account/export-and-close-account',
				'/settings/recover-wallet'
			].some(pn => pathname.startsWith(pn)),
		[pathname]
	);
};
